import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BookBasketOffer } from 'app/shared/models/class/basket/basketList';
import { BookingUser } from 'app/shared/models/class/booking-session/booking-session';
import { PaymentRefund, PaymentRefundGlobal, PaymentType } from 'app/shared/models/class/counter/counter';
import { SessionBasketBookable } from 'app/shared/models/class/session-basket/session-basket';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { CounterService } from 'app/shared/services/counter/counter.service';
import { SessionBasketService } from 'app/shared/services/session-basket/session-basket.service';
import { UiService } from 'app/shared/services/ui/ui.service';

export interface DialogData {
  title: string;
  action: string;
  tab: string;
  booking: BookingUser;
  paymentRefundList: PaymentRefundGlobal;
  myOrder: BookBasketOffer;
}

@Component({
  selector: 'app-open-dialog-payment-refund',
  templateUrl: './open-dialog-payment-refund.component.html',
  styleUrls: ['./open-dialog-payment-refund.component.scss']
})
export class OpenDialogPaymentRefundComponent implements OnInit {

  addPaymentDefundForm: UntypedFormGroup;
  paymentTypeList: PaymentType[];
  bookingKey: number;

  constructor(
    public dialogRef: MatDialogRef<OpenDialogPaymentRefundComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: UntypedFormBuilder,
    private counterService: CounterService,
    private authService: AuthService,
    private sessionBasketService: SessionBasketService,
    private uiService: UiService
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }


  onSubmit(): void {
    switch (this.data.tab) {
      case 'basketInProgress':
        // this.dialogRef.close({ tab: this.data.tab });
        this.sessionBasketService.checkSessionBasketBookable(this.data.myOrder.userKey).subscribe({
          next: res => {
            res.every((el: SessionBasketBookable) => el.isBookable) ?
              this.bookMyOrder() :
              this.uiService.showSnackbar('Une de vos sessions n\'est plus disponible');
          }
        });
        break;

      case 'basket':
        const amount = this.data.action !== 'defund' ? this.f.amount.value : -this.f.amount.value;
        const { sub: userKey } = this.authService.getDecodedToken();
        const payment = new PaymentRefund(this.data.booking.bookingKey, amount, this.f.type.value.paymentTypeKey, +userKey);
        this.addPaymentRefund(payment);
        break;

      default:
        break;
    }

  }

  private bookMyOrder(): void {
    this.sessionBasketService.bookOffer(this.data.myOrder).subscribe({
      next: async res => {
        const amount = this.f.amount.value;
        this.bookingKey = res;
        const { sub: userKey } = this.authService.getDecodedToken();
        const payment = new PaymentRefund(res, amount, this.f.type.value.paymentTypeKey, +userKey);
        this.addPaymentRefund(payment, true,);

      }
    });
  }

  private async addPaymentRefund(payment: PaymentRefund, basketInProgress = false) {
    const { tab } = await this.data;

    this.counterService.addPaymentRefund(payment).subscribe({
      next: () => this.dialogRef.close({ bookingKey: basketInProgress ? payment.bookingKey : this.bookingKey, tab })
    });
  }

  private getPaymentTypeList(): void {
    this.counterService.getPaymentTypeList().subscribe({
      next: paymentTypeList => this.paymentTypeList = paymentTypeList
    });
  }

  private initComponent(): void {
    this.getPaymentTypeList();
  }

  get f() {
    return this.addPaymentDefundForm.controls;
  }

  private initForm(): void {
    this.addPaymentDefundForm = this.formBuilder.group({
      amount: ['', Validators.required],
      type: ['', Validators.required]
    });
  }


}
